// auth.service.ts
import { Injectable } from '@angular/core';
import { EventTypes, OidcSecurityService, PublicEventsService } from 'angular-auth-oidc-client';
import { TextSizeService } from './text-size.service';
import { jwtDecode, JwtPayload } from 'jwt-decode';
import { SignalsService } from './signals/signals.service';
import { ApiCacheService } from './cache-service/api-cache.service';
import { AppService } from 'app/app.service';
import { AdminService } from 'app/features/admin/admin.service';
import { filter } from 'rxjs';
import { Router } from '@angular/router';

const STORAGE_KEY = 'auth.redirectUrl';

@Injectable({ providedIn: 'root' })
export class AuthService {
  private initialized = false;

  constructor(
    private oidcService: OidcSecurityService,
    private signalService: SignalsService,
    private textSizeService: TextSizeService,
    private cacheService: ApiCacheService,
    private appService: AppService,
    private adminService: AdminService,
    private publicEventService: PublicEventsService,
    private router: Router,
  ) {
    // Subscribe to authentication events and check for saved routes to redirect after login
    this.publicEventService.registerForEvents().pipe(
      (filter((notification) => notification.type === EventTypes.NewAuthenticationResult))
    ).subscribe((_) => {
      const savedRoute = sessionStorage.getItem(STORAGE_KEY);
      sessionStorage.removeItem(STORAGE_KEY);

      if (savedRoute && savedRoute.startsWith('/')) {
        this.router.navigateByUrl(savedRoute);
      } else {
        this.router.navigate(['/flights/flight-table']);
      }
    });
    // Initial auth check on service instantiation
    this.checkAuth();
  }

  checkAuth(): void {
    console.log("%cAuthenticating User...", "color: lightgreen");
    this.oidcService.checkAuth().subscribe((response) => {
      console.log(`%cIs authenticated: %c${response?.isAuthenticated}`, "color: lightgreen", "color: white");
      const token = response.accessToken;
      const decoded: JwtPayload & { role?: string[] } = jwtDecode(token);
      if (decoded.role) {
        const adminRole = decoded.role.some((role) => {
          return (role === 'Logbook Admins');
        });
        console.log(`%cIs Admin: %c${adminRole}`, "color: lightgreen", "color: white");
        this.signalService._isAdminRole$.next(adminRole);
      }
      // Login not necessary, because route guards handle that.
      // Set employee number. upn is username and is empnum@[env].unionpilots.org.
      const empNumPattern = /(?<empnum>[^@]*)/; // Get everything before the @ char.
      const username = response?.userData?.upn || '';
      const empNum = username.match(empNumPattern)?.groups?.['empnum'];
      this.sameUserCheck(empNum);

    });
  }

  sameUserCheck(empNum: string | undefined): void {
    const currentMember = localStorage.getItem('member.loggedin');
    const currentCrewDetail = currentMember ? JSON.parse(currentMember) : null;

    if (empNum &&
      currentCrewDetail != null &&
      currentCrewDetail.memberDetails[0].username === empNum) {
      console.log(`%cActive EmpNumber: %c${empNum}`, "color: lightgreen", "color: white");
      this.signalService._authEmployeeNumber.next(empNum);
      this.signalService._empNumberObs.next(empNum);
    }
    else {
      this.adminService.clearAllStorage('mobile');
      this.signalService._authEmployeeNumber.next(empNum || '');
      this.signalService._empNumberObs.next(empNum || '');
    }
    // Init text service for navbar size
    this.textSizeService.initNavBarSizeWatcher();

    //Clear old cache greater than 7 days
    this.cacheService.clearOldCache();

    //Init version data
    this.appService.initializeVersionData();

    // Init app settings
    this.appService.initializeAppSettings();
  }


  // private decodeToken(token: string): any {
  //   try {
  //     const payload = token.split(".")[1];
  //     const base64 = payload.replace(/-/g, "+").replace(/_/g, "/");
  //     const jsonPayload = decodeURIComponent(
  //       window
  //         .atob(base64)
  //         .split("")
  //         .map(function (c) {
  //           return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
  //         })
  //         .join("")
  //     );
  //     const decoded = JSON.parse(jsonPayload);
  //     return decoded;
  //   } catch (error) {
  //     console.error("Failed to decode JWT", error);
  //     return null;
  //   }
  // }
}
